export function trimToNull(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  return trimmedValue || null;
}

export function formatLineValue(value: number): string {
  return Number.isInteger(value) ? `${value}` : value.toFixed(1);
}

export function splitSpecialOddsValue(value: string): { primary: string | null; secondary: string | null } {
  const separatorIndex = value.indexOf('-');
  if (separatorIndex <= 0 || separatorIndex === value.length - 1) {
    return {
      primary: null,
      secondary: null
    };
  }

  const primary = value.slice(0, separatorIndex).trim();
  const secondary = value.slice(separatorIndex + 1).trim();

  return {
    primary: primary ? primary : null,
    secondary: secondary ? secondary : null
  };
}

export function formatCorrectScoreLabel(value: string): string {
  if (value === 'OTHER') {
    return 'Other';
  }

  if (/^\d{2}$/.test(value)) {
    return `${value[0]}:${value[1]}`;
  }

  return value.replace(/_/g, ':');
}

export function normalizeLanguageCode(language: string): string {
  return language.trim().toLowerCase().replace(/_/g, '-');
}

export function tokenizeSearchText(value: string): readonly string[] {
  const normalized = normalizeSearchText(value);
  return normalized ? normalized.split(' ') : [];
}

export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

export function assertNever(value: never): never {
  throw new Error(`Unhandled selection resolver: ${String(value)}`);
}
